const Config = require('./Config.js');
import bchaddr from 'bchaddrjs';

// eslint-disable-next-line import/prefer-default-export
export const ConstantUtil = {};
let allLanguage = [
    { id: 1, code: 'en', name: 'English' },
    { id: 2, code: 'zhCN', name: '简体中文' },
    { id: 3, code: 'zhHK', name: '繁體中文' },
    { id: 4, code: 'ja', name: '日本語' },
    { id: 5, code: 'tr', name: 'Türk dili' },
];

if (Config.CenterTrade) {
    allLanguage = Config.allLanguage;
}
let showLanguage = [];
if (!Config.Language || Config.Language.length === 0) {
    showLanguage = allLanguage;
} else {
    const languageMap = {};
    for (let i = 0; i < allLanguage.length; i += 1) {
        languageMap[allLanguage[i].code] = allLanguage[i];
    }
    for (let i = 0; i < Config.Language.length; i += 1) {
        if (languageMap[Config.Language[i]]) {
            showLanguage.push(languageMap[Config.Language[i]]);
        }
    }
}

ConstantUtil.ENV = {
    TEST: 'TEST',
    PRODUCTION: 'PRODUCTION',
    INNER: 'INNER',
    PARTNER: 'PARTNER',
};

ConstantUtil.LanguageArray = showLanguage;
let allHost = [];

if (process.env.NODE_RUN_ENV.toUpperCase() === ConstantUtil.ENV.TEST) {
    allHost = [
        { id: 2, code: 'c2', name: 'nav_country_virginia', host: '//c2.bytetrade.com', ws: 'wss://c2.bytetrade.com/ws/' },
        { id: 4, code: 'c4', name: 'nav_country_singapore', host: '//c4.bytetrade.com', ws: 'wss://c4.bytetrade.com/ws/' },
    ];
    ConstantUtil.config = {
        AIR_DROP_URL: 'https://airdrop_test.bytetrade.io/postWeiboUrl',
        AIR_DROP_AMOUNT: [50, 200, 400],
        DOMAIN: '//www_test.bytetrade.io',
    };
    ConstantUtil.TimetoneMap = {
        c1: 'Asia/Tokyo',
        c2: 'America/Chicago',
        c3: 'Europe/London',
        c4: 'Asia/Singapore',
        c5: 'Australia/Sydney',
        c6: 'America/Sao_Paulo',
        c7: 'America/Los_Angeles',
        c8: 'Asia/Seoul',
        c9: 'Europe/Berlin',
        c10: 'America/Chicago',
        c11: 'America/Los_Angeles',
    };
}
if (process.env.NODE_RUN_ENV.toUpperCase() === ConstantUtil.ENV.PRODUCTION) {
    allHost = [
        // { id: 1, code: 'p1', name: 'Tokyo', host: '//p1.bytetrade.com', ws: 'wss://p1.bytetrade.com/ws/' },
        { id: 2, code: 'p2', name: 'Virginia', host: '//p2.bytetrade.com', ws: 'wss://p2.bytetrade.com/ws/' },
        { id: 3, code: 'p3', name: 'London', host: '//p3.bytetrade.com', ws: 'wss://p3.bytetrade.com/ws/' },
        { id: 4, code: 'p4', name: 'Singapore', host: '//p4.bytetrade.com', ws: 'wss://p4.bytetrade.com/ws/' },
        // { id: 5, code: 'p5', name: 'Sydney', host: '//p5.bytetrade.com', ws: 'wss://p5.bytetrade.com/ws/' },
        // { id: 6, code: 'p6', name: 'Sao Paulo', host: '//p6.bytetrade.com', ws: 'wss://p6.bytetrade.com/ws/' },
        { id: 7, code: 'p7', name: 'California', host: '//p7.bytetrade.com', ws: 'wss://p7.bytetrade.com/ws/' },
        // { id: 8, code: 'p8', name: 'Seoul', host: '//p8.bytetrade.com', ws: 'wss://p8.bytetrade.com/ws/' },
        // { id: 9, code: 'p9', name: 'Frankfurt', host: '//p9.bytetrade.com', ws: 'wss://p9.bytetrade.com/ws/' },
        // { id: 10, code: 'p10', name: 'Ohio', host: '//p10.bytetrade.com', ws: 'wss://p10.bytetrade.com/ws/' },
        // { id: 11, code: 'p11', name: 'Oregon', host: '//p11.bytetrade.com', ws: 'wss://p11.bytetrade.com/ws/' },
    ];
    ConstantUtil.config = {
        AIR_DROP_URL: 'https://airdrop.bytetrade.io/postWeiboUrl',
        AIR_DROP_AMOUNT: [30, 60, 100],
        DOMAIN: '//bytetrade.io',
    };
    // 节点对应时区
    ConstantUtil.TimetoneMap = {
        p1: 'Asia/Tokyo',
        p2: 'America/Chicago',
        p3: 'Europe/London',
        p4: 'Asia/Singapore',
        p5: 'Australia/Sydney',
        p6: 'America/Sao_Paulo',
        p7: 'America/Los_Angeles',
        p8: 'Asia/Seoul',
        p9: 'Europe/Berlin',
        p10: 'America/Chicago',
        p11: 'America/Los_Angeles',
    };
}
ConstantUtil.HostArray = allHost;

ConstantUtil.Number = {
    BttFeeRate: 0.0005,
    PackageFee: 0.0003,
    CreateMarketFee: 1000,
};
ConstantUtil.LikeBTCChainIds = [2, 5, 6, 7, 8, 9, 15];
ConstantUtil.Links = {
    1: { symbol: 'ETH', name: 'Ethereum', TEST: 'https://rinkeby.etherscan.io/tx/', PRODUCTION: 'https://www.etherscan.io/tx/' },
    2: { symbol: 'BTC', name: 'Bitcoin', TEST: 'https://live.blockcypher.com/btc-testnet/tx/', PRODUCTION: 'https://live.blockcypher.com/btc/tx/' },
    3: { symbol: 'CMT', name: 'CyberMiles', TEST: 'https://testnet.cmttracking.io/tx/', PRODUCTION: 'https://www.cmttracking.io/tx/' },
    4: { symbol: 'NAKA', name: 'NakaChain', EST: 'https://testnet.explorer.nakachain.org/tx/', PRODUCTION: 'https://explorer.nakachain.org/tx/' },
    5: { symbol: 'LTC', name: 'Ltc', EST: 'https://testnet.explorer.nakachain.org/tx/', PRODUCTION: 'https://explorer.nakachain.org/tx/' },
    6: { symbol: 'BCH', name: 'BCH', EST: 'https://testnet.explorer.nakachain.org/tx/', PRODUCTION: 'https://explorer.nakachain.org/tx/' },
    7: { symbol: 'BSV', name: 'BSV', EST: 'https://testnet.explorer.nakachain.org/tx/', PRODUCTION: 'https://explorer.nakachain.org/tx/' },
    9: { symbol: 'DASH', name: 'DASH', EST: 'https://testnet.explorer.nakachain.org/tx/', PRODUCTION: 'https://explorer.nakachain.org/tx/' },

};
ConstantUtil.webSocket = {
    sign: {
        name: 'server.sign',
        code: 10000,
    },
    order: {
        name: 'order.subscribe',
        code: 10001,
    },
    cash: {
        name: 'cash.subscribe',
        code: 10002,
    },
    today: {
        name: 'today.subscribe',
        code: 10003,
    },
    asset: {
        name: 'asset.subscribe2',
        code: 10005,
    },
    depth: {
        name: 'depth.subscribe',
        code: 10006,
    },
    deals: {
        name: 'deals.subscribe',
        code: 10007,
    },
    assetQuery: {
        name: 'asset.query2',
        code: 10008,
    },
    cancelOrder: {
        name: 'order.unsubscribe',
        code: 20008,
    },
    cancelCash: {
        name: 'cash.unsubscribe',
        code: 20008,
    },
    cancelToday: {
        name: 'today.unsubscribe',
        code: 20009,
    },
    cancelAsset: {
        name: 'asset.unsubscribe2',
        code: 20010,
    },
    cancelDepth: {
        name: 'depth.unsubscribe',
        code: 20011,
    },
    cancelDeals: {
        name: 'deals.unsubscribe',
        code: 20012,
    },
    ping: {
        name: 'server.ping',
        code: 20013,
    },
};

ConstantUtil.interval = {
    socketTimer: Config.default.socketPingInterval,
};
ConstantUtil.BCHID = new Set([59, 85]);
ConstantUtil.toBCHAddress = address => (bchaddr.isValidAddress(address) ? bchaddr.toCashAddress(address) : address);



// WEBPACK FOOTER //
// ./src/utils/ConstantUtil.js